import { Controller } from "@hotwired/stimulus"

// OTP-style numeric input. Auto-advances on type, handles backspace,
// distribui colagem (Ctrl+V) com código inteiro entre as células.
export default class extends Controller {
  static targets = ["cell", "hidden"]

  connect() {
    // Habilita paste em qualquer célula — distribui dígitos a partir dela.
    this.boundPaste = this._onPaste.bind(this)
    this.cellTargets.forEach((cell) => cell.addEventListener("paste", this.boundPaste))
  }

  disconnect() {
    this.cellTargets.forEach((cell) => cell.removeEventListener("paste", this.boundPaste))
  }

  advance(e) {
    const idx = this.cellTargets.indexOf(e.target)
    e.target.value = e.target.value.replace(/\D/g, "").slice(0, 1)
    if (e.target.value && idx < this.cellTargets.length - 1) {
      this.cellTargets[idx + 1].focus()
    }
    this._syncHidden()
  }

  backspace(e) {
    if (e.key !== "Backspace" || e.target.value) return
    const idx = this.cellTargets.indexOf(e.target)
    if (idx > 0) this.cellTargets[idx - 1].focus()
  }

  _onPaste(e) {
    const text = (e.clipboardData || window.clipboardData)?.getData("text") || ""
    const digits = text.replace(/\D/g, "")
    if (digits.length === 0) return
    e.preventDefault()
    const start = this.cellTargets.indexOf(e.target)
    if (start < 0) return

    digits.split("").slice(0, this.cellTargets.length - start).forEach((d, i) => {
      this.cellTargets[start + i].value = d
    })
    // Foca a próxima célula vazia ou a última preenchida.
    const lastFilled = Math.min(start + digits.length, this.cellTargets.length) - 1
    const nextEmpty  = this.cellTargets.findIndex((c, i) => i >= start && !c.value)
    const target     = nextEmpty >= 0 ? this.cellTargets[nextEmpty] : this.cellTargets[lastFilled]
    target?.focus()
    this._syncHidden()
  }

  _syncHidden() {
    this.hiddenTarget.value = this.cellTargets.map((c) => c.value).join("")
  }
}
